export default __webpack_public_path__ + "static/placeholder-6d1f4844cf561eb1b429965720edbb27.png";